import v47Schema from "../client/schemaVersions/v47.js";
import v48Schema from "../client/schemaVersions/v48.js";
import { createMigration } from "@verdant-web/store";
export default createMigration(v47Schema, v48Schema, async ({ migrate }) => {
    // add or modify migration logic here. you must provide migrations for
    // any collections that have changed field types or added new non-nullable
    // fields without defaults
    // await migrate('collectionName', async (old) => ({ /* new */ }));
});
//# sourceMappingURL=v48.js.map